// extracted by mini-css-extract-plugin
export default {"background":"future_yNBDzo6a6oo3","yellowBackground":"future_btGxwCwPyIxA","greenBackground":"future_rbVUHof9aLYq"};